import { render, staticRenderFns } from "./WithdrawWait.vue?vue&type=template&id=ff095b30&scoped=true"
import script from "./WithdrawWait.vue?vue&type=script&lang=js"
export * from "./WithdrawWait.vue?vue&type=script&lang=js"
import style0 from "./WithdrawWait.vue?vue&type=style&index=0&id=ff095b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff095b30",
  null
  
)

export default component.exports